// extracted by mini-css-extract-plugin
export default {"button":"style__button___OOW7f","image":"style__image___UmmnW","label":"style__label___DjDrC"};